<template>
    <div class="tab-content-container">
        <!--    vignettes    -->
        <div class="tab-header-container">
            <h2 class="form-label">Винетки</h2>
            <LiteButton @click.native="addVignette"
                        class="edit-button"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <!-- One Vignette -->
        <div class="item-container very-light-shadow"
             style="padding-bottom: 0;"
             v-for="vignette in vignettes" :key="vignette.id">
            <LiteButton @click.native="editVignette(vignette)"
                        class="edit-button"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getLastModifiedDate(vignette)"></p>
                <p class="last-modified-name" v-text="getLastModifiedBy(vignette)"></p>
            </div>
            <TextField class="text-field"
                       style="margin-top: 45px;"
                       :label="'Дата на изтичане на валидност'"
                       :value="vignette.expiryDate">
            </TextField>
            <TextField class="text-field"
                       :label="'Държава'"
                       :value="vignette.country.name">
            </TextField>
        </div>

        <!-- Edit/Add Note -->
        <CarVignettesEditForm v-if="shouldEdit" :vignette="currentEditVignette" @close-clicked="closeEdit"/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import mapperService from "@/services/mapper.service";
    import LiteButton from "@/shared/components/button/LiteButton"
    import {cloneDeep} from 'lodash';
    import CarVignettesEditForm from "@/components/car/form/CarVignettesEditForm";
    import TextField from "@/shared/components/TextField";
    import dateService from "@/services/date.service";

    export default {
        name: "CarVignettes",
        components: {TextField, CarVignettesEditForm, LiteButton},
        created() {
            this.vignettes = cloneDeep(this.carVignettes);
        },
        data() {
            return {
                carId: this.$route.params.id,
                vignettes: cloneDeep(this.carVignettes),
                shouldEdit: false,
                currentEditVignette: null
            }
        },
        methods: {
            getLastModifiedBy(vignette) {
                return mapperService.getLastModifiedBy(vignette);
            },
            getLastModifiedDate(vignette) {
                return mapperService.getLastModifiedDate(vignette);
            },
            formatDate(date) {
                if (date) {
                    return dateService.formatDate(date);
                }
                return '';
            },
            addVignette() {
                this.currentEditVignette = {};
                this.currentEditVignette.carId = this.carId;
                this.$store.commit('setHasModal', true);
                this.shouldEdit = true;
            },
            editVignette(vignette) {
                this.currentEditVignette = vignette;
                this.currentEditVignette.carId = this.carId;
                this.$store.commit('setHasModal', true);
                this.shouldEdit = true;
            },
            closeEdit() {
                this.currentEditVignette = null;
                this.$store.commit('setHasModal', false);
                this.shouldEdit = false;
            }
        },
        computed: {
            ...mapGetters(['carVignettes'])
        },
        watch: {
            carVignettes: {
                handler(newVal) {
                    if (newVal) {
                        this.vignettes = cloneDeep(newVal);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
</style>